import { Suspense } from 'react'
import { Outlet } from 'react-router'

import Loading from '@/components/generics/Loading'
import RouterStoreProvider from '@/contexts/router'
import { GuideTourAppProvider } from '@/tours'

export function RootLayout() {
  return (
    <Suspense fallback={<Loading />}>
      <RouterStoreProvider>
        <GuideTourAppProvider>
          <Outlet />
        </GuideTourAppProvider>
      </RouterStoreProvider>
    </Suspense>
  )
}
